<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p style="text-align: center;"><span dir="rtl">شكر إلى السيِّد أنطوان سعد وعلى نصائحه التي لا يبخل بإعطائها بكل محبَّة.</span></p>
<p style="text-align: center;"><span dir="rtl">إلى ليا شماطه، وجدتُ اللغة جميلة عندما رأيتُها مِن عينيك.</span></p>
<p style="text-align: center;"><span dir="rtl">شكرًا على تدقيقك.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?0ab454dc